import React from 'react';

const FacebookIcon = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.3356 2.75H3.66437C3.42242 2.7518 3.19089 2.84871 3.0198 3.0198C2.84871 3.19089 2.7518 3.42242 2.75 3.66437V18.3356C2.7518 18.5776 2.84871 18.8091 3.0198 18.9802C3.19089 19.1513 3.42242 19.2482 3.66437 19.25H11.5637V12.87H9.41875V10.3744H11.5637V8.53875C11.5637 6.4075 12.8631 5.24563 14.7744 5.24563C15.4137 5.24563 16.0531 5.24562 16.6925 5.34187V7.5625H15.3794C14.3413 7.5625 14.1419 8.0575 14.1419 8.77938V10.3675H16.6169L16.2938 12.8631H14.1419V19.25H18.3356C18.5776 19.2482 18.8091 19.1513 18.9802 18.9802C19.1513 18.8091 19.2482 18.5776 19.25 18.3356V3.66437C19.2482 3.42242 19.1513 3.19089 18.9802 3.0198C18.8091 2.84871 18.5776 2.7518 18.3356 2.75V2.75Z"
      fill="#B0B9D5"
    />
  </svg>
);

export default FacebookIcon;
